import React from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { Button, Icon, USER_PERMISSIONS } from "dyl-components";
import RestrictedView from "shared/RestrictedView";

const Toolbar = ({ onAddTag }) => {
    return (
        <Grid>
            <Grid.Row columns="equal" verticalAlign="middle">
                <Grid.Column floated="right">
                    <RestrictedView userPermission={USER_PERMISSIONS.LIBRARY_ADD} type='disabled'>
                    <Button
                        floated="right"
                        disabled={!onAddTag}
                        onClick={onAddTag}
                    >
                        <Icon name="plus" /> New Call Tag
                    </Button>
                    </RestrictedView>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

Toolbar.propTypes = {
    onAddTag: PropTypes.func.isRequired,
};

export default Toolbar;
